module.exports = __webpack_public_path__ + "static/media/feedback-icon.a6b49eb4.svg";